import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/ends-with";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

/**
 * This file is a copy of the quill blots/scroll.js
 * We are fixing an issue where the DOMNodeInserted is getting deprecated at the end of July 2024 https://chromestatus.com/feature/5083947249172480
 */
import { Quill } from 'react-quill'; //import the blots/formats that we need for redefining the Scroll

var Parchment = Quill["import"]('parchment');
var Block = Quill["import"]('blots/block');
var BlockEmbed = Quill["import"]('blots/block/embed');
var Break = Quill["import"]('blots/break');
var CodeBlock = Quill["import"]('formats/code-block');
var Container = Quill["import"]('blots/container');
/**
 * emitter is not being exported, so redefine what we need
 */

var Emitter = {
  events: {
    EDITOR_CHANGE: 'editor-change',
    SCROLL_BEFORE_UPDATE: 'scroll-before-update',
    SCROLL_OPTIMIZE: 'scroll-optimize',
    SCROLL_UPDATE: 'scroll-update',
    SELECTION_CHANGE: 'selection-change',
    TEXT_CHANGE: 'text-change'
  },
  sources: {
    API: Quill.sources.API,
    SILENT: Quill.sources.SILENT,
    USER: Quill.sources.USER
  }
};
/**
 * copied from quill
 */

function isLine(blot) {
  return blot instanceof Block || blot instanceof BlockEmbed;
}
/**
 * copied from quill, we are fixing issue https://github.com/quilljs/quill/issues/3806, related to deprecating DOMNodeInserted
 */


var Scroll = /*#__PURE__*/function (_Parchment$Scroll) {
  _inheritsLoose(Scroll, _Parchment$Scroll);

  function Scroll(domNode, config) {
    var _this;

    _this = _Parchment$Scroll.call(this, domNode) || this;
    _this.emitter = config.emitter;

    if (_Array$isArray(config.whitelist)) {
      var _context;

      _this.whitelist = _reduceInstanceProperty(_context = config.whitelist).call(_context, function (whitelist, format) {
        whitelist[format] = true;
        return whitelist;
      }, {});
    } // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
    //[janos.kun@cheetahdigital.com]/March 2024: this is the line of code being deprecated. Because of this we had to copy the scroll blot
    //this.domNode.addEventListener('DOMNodeInserted', function() {});
    //[janos.kun@cheetahdigital.com]/March 2024: the following two lines are replacing the deprecated addEventListener('DOMNodeInserted' that I commented out above


    var observer = new MutationObserver(function () {});
    observer.observe(_this.domNode, {
      childList: true
    });

    _this.optimize();

    _this.enable();

    return _this;
  }

  var _proto = Scroll.prototype;

  _proto.batchStart = function batchStart() {
    this.batch = true;
  };

  _proto.batchEnd = function batchEnd() {
    this.batch = false;
    this.optimize();
  };

  _proto.deleteAt = function deleteAt(index, length) {
    var _this$line = this.line(index),
        first = _this$line[0],
        offset = _this$line[1];

    var _this$line2 = this.line(index + length),
        last = _this$line2[0];

    _Parchment$Scroll.prototype.deleteAt.call(this, index, length);

    if (last != null && first !== last && offset > 0) {
      if (first instanceof BlockEmbed || last instanceof BlockEmbed) {
        this.optimize();
        return;
      }

      if (first instanceof CodeBlock) {
        var newlineIndex = first.newlineIndex(first.length(), true);

        if (newlineIndex > -1) {
          first = first.split(newlineIndex + 1);

          if (first === last) {
            this.optimize();
            return;
          }
        }
      } else if (last instanceof CodeBlock) {
        var _newlineIndex = last.newlineIndex(0);

        if (_newlineIndex > -1) {
          last.split(_newlineIndex + 1);
        }
      }

      var ref = last.children.head instanceof Break ? null : last.children.head;
      first.moveChildren(last, ref);
      first.remove();
    }

    this.optimize();
  };

  _proto.enable = function enable(enabled) {
    if (enabled === void 0) {
      enabled = true;
    }

    this.domNode.setAttribute('contenteditable', enabled);
  };

  _proto.formatAt = function formatAt(index, length, format, value) {
    if (this.whitelist != null && !this.whitelist[format]) return;

    _Parchment$Scroll.prototype.formatAt.call(this, index, length, format, value);

    this.optimize();
  };

  _proto.insertAt = function insertAt(index, value, def) {
    if (def != null && this.whitelist != null && !this.whitelist[value]) return;

    if (index >= this.length()) {
      if (def == null || Parchment.query(value, Parchment.Scope.BLOCK) == null) {
        var blot = Parchment.create(this.statics.defaultChild);
        this.appendChild(blot);

        if (def == null && _endsWithInstanceProperty(value).call(value, '\n')) {
          value = _sliceInstanceProperty(value).call(value, 0, -1);
        }

        blot.insertAt(0, value, def);
      } else {
        var embed = Parchment.create(value, def);
        this.appendChild(embed);
      }
    } else {
      _Parchment$Scroll.prototype.insertAt.call(this, index, value, def);
    }

    this.optimize();
  };

  _proto.insertBefore = function insertBefore(blot, ref) {
    if (blot.statics.scope === Parchment.Scope.INLINE_BLOT) {
      var wrapper = Parchment.create(this.statics.defaultChild);
      wrapper.appendChild(blot);
      blot = wrapper;
    }

    _Parchment$Scroll.prototype.insertBefore.call(this, blot, ref);
  };

  _proto.leaf = function leaf(index) {
    return this.path(index).pop() || [null, -1];
  };

  _proto.line = function line(index) {
    if (index === this.length()) {
      return this.line(index - 1);
    }

    return this.descendant(isLine, index);
  };

  _proto.lines = function lines(index, length) {
    if (index === void 0) {
      index = 0;
    }

    if (length === void 0) {
      length = Number.MAX_VALUE;
    }

    var getLines = function getLines(blot, index, length) {
      var lines = [],
          lengthLeft = length;
      blot.children.forEachAt(index, length, function (child, index, length) {
        if (isLine(child)) {
          lines.push(child);
        } else if (child instanceof Parchment.Container) {
          lines = _concatInstanceProperty(lines).call(lines, getLines(child, index, lengthLeft));
        }

        lengthLeft -= length;
      });
      return lines;
    };

    return getLines(this, index, length);
  };

  _proto.optimize = function optimize(mutations, context) {
    if (mutations === void 0) {
      mutations = [];
    }

    if (context === void 0) {
      context = {};
    }

    if (this.batch === true) return;

    _Parchment$Scroll.prototype.optimize.call(this, mutations, context);

    if (mutations.length > 0) {
      this.emitter.emit(Emitter.events.SCROLL_OPTIMIZE, mutations, context);
    }
  };

  _proto.path = function path(index) {
    var _context2;

    return _sliceInstanceProperty(_context2 = _Parchment$Scroll.prototype.path.call(this, index)).call(_context2, 1); // Exclude self
  };

  _proto.update = function update(mutations) {
    if (this.batch === true) return;
    var source = Emitter.sources.USER;

    if (typeof mutations === 'string') {
      source = mutations;
    }

    if (!_Array$isArray(mutations)) {
      mutations = this.observer.takeRecords();
    }

    if (mutations.length > 0) {
      this.emitter.emit(Emitter.events.SCROLL_BEFORE_UPDATE, source, mutations);
    }

    _Parchment$Scroll.prototype.update.call(this, _concatInstanceProperty(mutations).call(mutations, [])); // pass copy


    if (this.emitter && mutations.length > 0) {
      this.emitter.emit(Emitter.events.SCROLL_UPDATE, source, mutations);
    }
  };

  return Scroll;
}(Parchment.Scroll);

Scroll.blotName = 'scroll';
Scroll.className = 'ql-editor';
Scroll.tagName = 'DIV';
Scroll.defaultChild = 'block';
Scroll.allowedChildren = [Block, BlockEmbed, Container];
export default Scroll;
//# sourceMappingURL=custom-scroll-blot.js.map